interface IProps {
  type?: "float" | "int";
  value: any;
  toFixed?: number;
  rupee?: { is: boolean; style?: "decimal" | "currency" | "percent" | "unit" };
}

const parseNumber = ({ type = "int", value, toFixed, rupee = { is: false, style: "decimal" } }: IProps) => {
  try {
    if (rupee.is) {
      const nValue: any = parseInt(value, 10);

      if (Number.isNaN(nValue)) {
        return 0;
      }

      if (!nValue) return 0;
      if (typeof nValue !== "number") return 0;

      return new Intl.NumberFormat("en-IN", {
        style: rupee.style,
        currency: "INR",
        minimumFractionDigits: toFixed ?? 2, // Ensures two decimal places
      }).format(nValue);
    }

    if (type === "int") {
      const nValue: any = parseInt(value, 10);

      if (Number.isNaN(nValue)) {
        return 0;
      }

      return nValue;
    } else if (type === "float") {
      let nValue: any = parseFloat(value);

      if (toFixed) {
        nValue = nValue.toFixed(toFixed);
      }

      if (Number.isNaN(nValue)) {
        return 0;
      }

      return nValue;
    }

    return 0;
  } catch (error) {
    return 0;
  }
};

export default parseNumber;
